import { render, staticRenderFns } from "./card-visual.vue?vue&type=template&id=827470dc&"
import script from "./card-visual.vue?vue&type=script&lang=js&"
export * from "./card-visual.vue?vue&type=script&lang=js&"
import style0 from "./card-visual.vue?vue&type=style&index=0&id=827470dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports